import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import payrollnootLogo from '../assets/images/payrollnoot-logo-lg.png';
import routes from 'constants/routes';
import '../styles/main.scss';

const menuItems = [
    {
        name: 'Dashboard',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        path: routes.CONTRACTOR_PORTAL.HOME,
    },
    {
        name: 'Manage Contractor Profile',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
            </svg>
        ),
        path: `${routes.CONTRACTOR_PORTAL.HOME}${routes.CONTRACTOR_PORTAL.PROFILE}`,
    },
    {
        name: 'Clock Time',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <polyline points="12 6 12 12 16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        path: `${routes.CONTRACTOR_PORTAL.HOME}${routes.CONTRACTOR_PORTAL.CLOCK_TIME}`,
    },
    {
        name: 'Payments',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
        ),
        path: `${routes.CONTRACTOR_PORTAL.HOME}${routes.CONTRACTOR_PORTAL.PAYMENTS}`,
    },
    {
        name: 'Documents',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
        ),
        path: `${routes.CONTRACTOR_PORTAL.HOME}${routes.CONTRACTOR_PORTAL.DOCUMENTS}`,
    },
    {
        name: 'Bank Account',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
        ),
        path: `${routes.CONTRACTOR_PORTAL.HOME}${routes.CONTRACTOR_PORTAL.BANK_ACCOUNT}`,
    },
    {
        name: 'Account',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="2" />
            </svg>
        ),
        path: `${routes.CONTRACTOR_PORTAL.HOME}${routes.CONTRACTOR_PORTAL.ACCOUNT}`,
    },
];

const ContractorSidebar = ({ isOpen = true, onClose }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <div className={`cp-sidebar${isOpen ? ' sidebar-open' : ''}`} style={{
            width: 260,
            minWidth: 260,
            background: '#fff',
            borderRight: '1px solid #f0f0f0',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '2px 0 8px rgba(0,0,0,0.04)',
        }}>
            {/* Logo */}
            <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid #f5f5f5' }}>
                <img src={payrollnootLogo} alt="PayrollNoot" style={{ height: 70, objectFit: 'contain' }} />
            </div>

            {/* Menu */}
            <ul style={{ listStyle: 'none', padding: '12px 0', margin: 0, flex: 1 }}>
                {menuItems.map((item) => {
                    const isActive = pathname === item.path ||
                        (item.path !== routes.CONTRACTOR_PORTAL.HOME && pathname.startsWith(item.path));
                    return (
                        <li key={item.path}>
                            <button
                                onClick={() => navigate(item.path)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    padding: '13px 16px',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    borderRadius: 8,
                                    margin: '2px 8px',
                                    width: 'calc(100% - 16px)',
                                    color: isActive ? '#1B75F0' : '#555',
                                    fontWeight: isActive ? 600 : 400,
                                    fontSize: 16,
                                    fontFamily: '"Poppins", serif',
                                    transition: 'all 0.15s',
                                    backgroundColor: isActive ? 'rgba(27, 117, 240, 0.07)' : 'transparent',
                                }}
                            >
                                <span style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 36,
                                    height: 36,
                                    borderRadius: 8,
                                    background: isActive ? 'rgba(27, 117, 240, 0.1)' : '#f5f5f5',
                                    color: isActive ? '#1B75F0' : '#888',
                                    flexShrink: 0,
                                }}>
                                    {item.icon}
                                </span>
                                <span style={{ flex: 1 }}>{item.name}</span>
                                <svg viewBox="0 0 24 24" fill="none" width="14" height="14" style={{ opacity: 0.4 }}>
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ContractorSidebar;
